export const LOAD_NOTIFICATIONS = 'notifications/LOAD_NOTIFICATIONS';
export const SAVE_NOTIFICATIONS = 'notification/SAVE_NOTIFICATIONS';
